import { FC } from 'react'
import { Table } from 'antd'
import { PageSpinner, Space, Title } from '@signifyd/components'
import { spacingMD } from '@signifyd/ant'
import { SuiteName } from '@signifyd/cypress'
import { useGetRuns } from 'lib/queries/useGetRuns/useGetRuns'
import { getDashboardColumns } from './utils'

interface Props {
  suite: SuiteName
}

export const DashboardItem: FC<Props> = ({ suite }) => {
  const { data, isLoading } = useGetRuns({ suite })

  if (isLoading) {
    return <PageSpinner />
  }

  if (!data) {
    return null
  }

  return (
    <>
      <Title>Latest runs</Title>
      <Space size={spacingMD} />
      <Table
        columns={getDashboardColumns(suite)}
        dataSource={data}
        rowKey="runId"
        pagination={false}
      />
    </>
  )
}
